import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslations from "./locales/en.json";
import mmTranslations from "./locales/mm.json";
import jaTranslations from "./locales/ja.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      mm: {
        translation: mmTranslations,
      },
      ja: {
        translation: jaTranslations,
      },
    },
    fallbackLng: "ja",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["htmlTag", "navigator", "localStorage"],
      caches: ["localStorage"],
    },
  });

export default i18n;
